__turbopack_context__.v({
  "activeFilters": "gt68QG_activeFilters",
  "container": "gt68QG_container",
  "desktopSortByFilter": "gt68QG_desktopSortByFilter",
  "dropdownsContainer": "gt68QG_dropdownsContainer",
  "filtersContainer": "gt68QG_filtersContainer",
  "hidden": "gt68QG_hidden",
  "mobileButton": "gt68QG_mobileButton",
  "mobileControls": "gt68QG_mobileControls",
  "mobileFilterButton": "gt68QG_mobileFilterButton" + " " + "gt68QG_mobileButton",
  "mobileFilterButton--active": "gt68QG_mobileFilterButton--active",
  "mobileSortButton": "gt68QG_mobileSortButton" + " " + "gt68QG_mobileButton",
});
